import { useEffect } from 'react';

const SITE_NAME = 'Checkstall Import Admin';

export default function PageMeta({ title, description }) {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    document.title = fullTitle;

    let meta = document.querySelector('meta[name="description"]');
    if (description) {
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    } else if (meta) {
      meta.setAttribute('content', '');
    }
  }, [title, description]);

  return null;
}

export { SITE_NAME };

